import { StyledTable } from '@/shared/ui/tables'
import React from 'react'
import moment from 'moment'
import {
    Alert,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Button,
    Stack,
    Grid,
    Box,
    Typography,
    LinearProgress,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faChevronLeft } from '@fortawesome/pro-duotone-svg-icons/faChevronLeft'
import { faChevronRight } from '@fortawesome/pro-duotone-svg-icons/faChevronRight'

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import { Link } from 'react-router-dom'
import { LoadingDefault } from '@/shared/ui/loading'

export default class App extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            day: 0,
            month: moment().toDate(),
            events: [],
            locations: [],
            monthPicker: false,
        }

        this.openDatePicker = this.openDatePicker.bind(this)
    }

    incrementDay() {
        this.setState(
            {
                day: this.state.day + 1,
            },
            () => this.updateDays()
        )
    }

    decrementDay() {
        this.setState(
            {
                day: this.state.day - 1,
            },
            () => this.updateDays()
        )
    }

    updateDays() {
        this.setState({
            today: moment(this.state.month).add(this.state.day, 'days'),
            tomorrow: moment(this.state.month).add(this.state.day + 1, 'days'),
            day_after_tomorrow: moment(this.state.month).add(
                this.state.day + 2,
                'days'
            ),
        })
    }

    fetchData() {
        if (!this.props.data) {
            return
        }

        return this.props.data.dossiers.map((dossier) => {
            let options = this.props.templateOptions
                ? this.props.templateOptions
                : null

            let event = this.props.data.contents.filter(
                (content) => content.id === dossier.id
            )
            let name =
                options && options.name
                    ? event.find((field) => field.content.id === options.name)
                    : null
            let location =
                options && options.location
                    ? event.find(
                          (field) => field.content.id === options.location
                      )
                    : null
            let start =
                options && options.start
                    ? event.find((field) => field.content.id === options.start)
                    : null
            let end =
                options && options.end
                    ? event.find((field) => field.content.id === options.end)
                    : null

            let events = this.state.events

            if (
                options &&
                options.name !== null &&
                options.location !== null &&
                options.start !== null &&
                options.end !== null
            ) {
                events.push({
                    id: dossier.id,
                    name: name.content.content,
                    start: start.content.content,
                    end: end.content.content,
                    location: location.content.content[0].summary,
                })

                let locations = this.state.locations

                if (
                    locations.find(
                        (loc) => loc.id === location.content.content[0].id
                    ) === undefined
                ) {
                    locations.push({
                        id: location.content.content[0].id,
                        name: location.content.content[0].summary,
                    })
                }

                this.setState({ locations: locations })
            }
        })
    }

    componentDidMount() {
        this.updateDays()
        this.fetchData()
    }

    checkDate(date, isSame) {
        var iscurrentDate = moment(date).isSame(isSame, 'day')
        if (iscurrentDate) {
            return true
        }
    }

    renderEvents(location) {
        let events = this.state.events.filter(
            (event) => event.location === location.name
        )

        let days = [
            this.state.today,
            this.state.tomorrow,
            this.state.day_after_tomorrow,
        ]

        return (
            <>
                {days.map((dayItem) => (
                    <TableCell
                        key={`${dayItem}-${location.id}`}
                        align="center"
                        sx={{ width: '33%' }}
                    >
                        {events.map((item) => {
                            if (
                                moment(item.start).format('DD/MM/YYYY') ===
                                moment(dayItem).format('DD/MM/YYYY')
                            ) {
                                return (
                                    <Link
                                        key={`day-item-${item.id}`}
                                        to={`/contentdossier/${item.id}`}
                                    >
                                        <LinearProgress
                                            variant="determinate"
                                            value={100}
                                            sx={{
                                                height: 20,
                                                borderRadius: 2,
                                                mb: 0.5,
                                                '& .MuiLinearProgress-bar': {
                                                    bgcolor: 'success.main',
                                                },
                                                bgcolor: 'grey.300',
                                            }}
                                        />
                                        <Typography variant="caption">
                                            {item.name}
                                        </Typography>
                                    </Link>
                                )
                            }
                            if (
                                moment(item.end).format('DD/MM/YYYY') ===
                                moment(dayItem).format('DD/MM/YYYY')
                            ) {
                                return (
                                    <Link
                                        key={`day-item-${item.id}`}
                                        to={`/contentdossier/${item.id}`}
                                    >
                                        <LinearProgress
                                            variant="determinate"
                                            value={100}
                                            sx={{
                                                height: 20,
                                                borderRadius: 2,
                                                mb: 0.5,
                                                '& .MuiLinearProgress-bar': {
                                                    bgcolor: 'error.main',
                                                },
                                                bgcolor: 'grey.300',
                                            }}
                                        />
                                        <Typography variant="caption">
                                            {item.name}
                                        </Typography>
                                    </Link>
                                )
                            }
                        })}
                    </TableCell>
                ))}
            </>
        )
    }

    openDatePicker() {
        this.setState({
            monthPicker: !this.state.monthPicker,
        })
    }

    render() {
        let options = this.props.templateOptions
            ? this.props.templateOptions
            : null

        if (
            options === null ||
            options.name === null ||
            options.location === null ||
            options.start === null ||
            options.end === null
        ) {
            return (
                <Alert severity={'warning'}>
                    {this.props.kedo.t(
                        'Event module not properly setup. Please guide your contract admin.'
                    )}
                </Alert>
            )
        }

        if (this.state.loading) {
            return (
                <center>
                    <LoadingDefault />
                </center>
            )
        }

        return (
            <div id="eventcalendar">
                {this.state.monthPicker ? (
                    <div className={'custom-month'}>
                        {/* <DatePicker
            selected={moment(this.state.today).toDate()}
            onChange={(e) => {
              this.setState({
                month: e,
                day: 0
              }, () => {
                this.updateDays();
              });

              this.openDatePicker();
            }}
            dateFormat="MM/yyyy"
            showMonthYearPicker
            onClickOutside={this.openDatePicker}
            open={this.state.monthPicker}
            customInput={<></>}
          /> */}
                    </div>
                ) : null}
                <TableContainer component={Paper}>
                    <StyledTable
                        size="small"
                        sx={{
                            '& .MuiTableCell-root': {
                                border: 1,
                                borderColor: 'divider',
                            },
                        }}
                        striped
                    >
                        <TableHead>
                            <TableRow
                                sx={{
                                    '& .MuiTableCell-head, th': {
                                        textAlign: 'left',
                                        fontWeight: 'bold',
                                    },
                                }}
                            >
                                <TableCell colSpan={4}>
                                    <Grid
                                        container
                                        alignItems="center"
                                        justifyContent="space-between"
                                    >
                                        <Grid size={12}>
                                            <Typography
                                                variant="h6"
                                                align="center"
                                            >
                                                {moment(this.state.today)
                                                    .startOf('day')
                                                    .format('MMMM yyyy')}
                                            </Typography>
                                        </Grid>
                                        <Grid size={12}>
                                            <Stack
                                                direction="row"
                                                alignItems="stretch"
                                            >
                                                <Button
                                                    onClick={() =>
                                                        this.decrementDay()
                                                    }
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faChevronLeft}
                                                    />
                                                </Button>
                                                {/* Optional: Month picker button */}
                                                {/* <Button onClick={() => this.openDatePicker()}><FontAwesomeIcon icon={faCalendarAlt} /></Button> */}
                                                <Button
                                                    variant="light"
                                                    onClick={() =>
                                                        this.incrementDay()
                                                    }
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faChevronRight}
                                                    />
                                                </Button>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ width: '33%' }}>
                                    <Box
                                        display="flex"
                                        flexDirection="column"
                                        alignItems="center"
                                    >
                                        <Typography variant="body2">
                                            {moment(this.state.today).format(
                                                'ddd'
                                            )}
                                        </Typography>
                                        <Typography variant="body1">
                                            {moment(this.state.today).format(
                                                'DD'
                                            )}
                                        </Typography>
                                    </Box>
                                </TableCell>
                                <TableCell sx={{ width: '33%' }}>
                                    <Box
                                        display="flex"
                                        flexDirection="column"
                                        alignItems="center"
                                    >
                                        <Typography variant="body2">
                                            {moment(this.state.tomorrow).format(
                                                'ddd'
                                            )}
                                        </Typography>
                                        <Typography variant="body1">
                                            {moment(this.state.tomorrow).format(
                                                'DD'
                                            )}
                                        </Typography>
                                    </Box>
                                </TableCell>
                                <TableCell sx={{ width: '33%' }}>
                                    <Box
                                        display="flex"
                                        flexDirection="column"
                                        alignItems="center"
                                    >
                                        <Typography variant="body2">
                                            {moment(
                                                this.state.day_after_tomorrow
                                            ).format('ddd')}
                                        </Typography>
                                        <Typography variant="body1">
                                            {moment(
                                                this.state.day_after_tomorrow
                                            ).format('DD')}
                                        </Typography>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.locations.map((location) => {
                                return (
                                    <TableRow key={location.id}>
                                        TableRow
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </StyledTable>
                </TableContainer>
            </div>
        )
    }
}
